// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.brands_brands__QayyT {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 8px;
}
.brands_brands-inner__xsf9U {
  width: 100%;
  padding: 0 16px;
}
.brands_brands-title__2CW0j {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 3px;
  margin-bottom: 12px;
}
.brands_brands-title__2CW0j span {
  color: #fff;
  text-align: right;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
}
.brands_brands-title__2CW0j img {
}
.brands_brands-items__Cmm5x {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: wrap;
  gap: 8px;
}
.brands_brands-item__em8st {
  width: 48%;
  border-radius: 72px;
  border: 1px solid rgba(255, 255, 255, 0.24);
  background: rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(8px);
  height: 45px;
  padding: 10px 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 156px;
  min-height: 40px;
}

.brands_brands-item__em8st img {
  max-width: 105px;
  max-height: 39px;
  object-fit: contain;
}
@media screen and (min-width: 1000px) {
  .brands_brands-title__2CW0j span {
    font-size: 16px;
  }
  .brands_brands-item__em8st {
    width: 49%;
    /* min-width: 446px; */
    min-height: 45px;
  }
  .brands_item__FY9Ro img {
    width: 100%;
    max-width: unset;
    min-width: 565px;
    min-height: 252px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/brands/BrandsItems/brands.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;AACA;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;AACA;EACE,UAAU;EACV,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC,0BAA0B;EAC1B,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,UAAU;IACV,sBAAsB;IACtB,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;EACnB;AACF","sourcesContent":[".brands {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  margin-top: 8px;\n}\n.brands-inner {\n  width: 100%;\n  padding: 0 16px;\n}\n.brands-title {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 3px;\n  margin-bottom: 12px;\n}\n.brands-title span {\n  color: #fff;\n  text-align: right;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n}\n.brands-title img {\n}\n.brands-items {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-flow: wrap;\n  gap: 8px;\n}\n.brands-item {\n  width: 48%;\n  border-radius: 72px;\n  border: 1px solid rgba(255, 255, 255, 0.24);\n  background: rgba(255, 255, 255, 0.12);\n  backdrop-filter: blur(8px);\n  height: 45px;\n  padding: 10px 8px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-width: 156px;\n  min-height: 40px;\n}\n\n.brands-item img {\n  max-width: 105px;\n  max-height: 39px;\n  object-fit: contain;\n}\n@media screen and (min-width: 1000px) {\n  .brands-title span {\n    font-size: 16px;\n  }\n  .brands-item {\n    width: 49%;\n    /* min-width: 446px; */\n    min-height: 45px;\n  }\n  .item img {\n    width: 100%;\n    max-width: unset;\n    min-width: 565px;\n    min-height: 252px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"brands": `brands_brands__QayyT`,
	"brands-inner": `brands_brands-inner__xsf9U`,
	"brands-title": `brands_brands-title__2CW0j`,
	"brands-items": `brands_brands-items__Cmm5x`,
	"brands-item": `brands_brands-item__em8st`,
	"item": `brands_item__FY9Ro`
};
export default ___CSS_LOADER_EXPORT___;
